import React from "react";
import { withStyles } from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";

const styles = {
  textField: {
    margin: 0,
  },
  input: {
    height: "46px",
  },
  inputElement: {
    padding: "14.5px 10px",
  },
  inputSize: {
    fontSize: "0.875em",
  },
};

const CustomInputAuth = (props) => {
  const { classes } = props;
  const otherProps = { ...props };
  delete otherProps.classes;
  delete otherProps.endAdornment;

  return (
    <TextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      {...otherProps}
      InputProps={{
        classes: { input: classes.inputSize },
        className: classes.input,
        endAdornment: props.endAdornment,
        style: {
          alignItems: "center",
        },
      }}
      inputProps={{
        className: classes.inputElement,
      }}
    />
  );
};

export default withStyles(styles)(CustomInputAuth);
